import { DateObject, useIntl } from '@capsicum/common';
import { ParticipationCard, useRouter } from '@capsicum/common-web';
import { PollIcon } from '@capsicum/common-web/icons';
import { useTheme } from 'styled-components';

type PollCardProps = {
	claimingDate: DateObject;
	shortCode?: string;
	surveyId?: string;
	votingDate?: DateObject;
};

export const PollCard = ({ claimingDate, shortCode, surveyId, votingDate }: PollCardProps) => {
	const { colors } = useTheme();
	const { $t } = useIntl();
	const { replace } = useRouter();
	const today = new DateObject();
	const isStakingClaimable = claimingDate.diff(today, 'days') <= 0;

	const navigateToClaimConfirmationPage = () =>
		replace(`/nc-wallet/partner-details/${shortCode}/unstake-surveys/${surveyId}`);

	return (
		<ParticipationCard
			caption={isStakingClaimable ? $t('wallet.partnerDetails.staked.polls.clickToClaim') : ''}
			captionColor={colors.text.brand.enabled}
			chartLabel={`1 ${shortCode}`}
			clickable={isStakingClaimable}
			endDate={new DateObject(claimingDate)}
			icon={PollIcon}
			participationDate={new DateObject(claimingDate)}
			startDate={new DateObject(votingDate)}
			staticParticipationDate
			testID="walletPartnerDetails-stakedSection-pollCard"
			text={$t('wallet.partnerDetails.staked.polls.title')}
			onClick={() => isStakingClaimable && navigateToClaimConfirmationPage()}
		/>
	);
};
